import { DateIntervalFilterData } from "../models";

/**
 * Builds a `DateIntervalFilterData` object from a saved page filter.
 * 
 * If the page filter has a custom date range (`isCustomDate` is true), 
 * the function creates a new `DateIntervalFilterData` with updated
 * start/end and previous cycle dates converted to `Date` objects.  
 * Otherwise, it merges only the `interval` and `granularity` into the
 * existing `dateFilter`.
 * 
 * @returns {DateIntervalFilterData} The updated date filter object.
 */
export function buildDateFilterFromPageFilter(dateFilter: DateIntervalFilterData, pageFilter: any): DateIntervalFilterData {
  return pageFilter.isCustomDate ? {
    ...pageFilter,
    startDate: new Date(pageFilter.startDate),
    endDate: new Date(pageFilter.endDate),
    previousCycleStartDate: new Date(pageFilter.previousCycleStartDate),
    previousCycleEndDate: new Date(pageFilter.previousCycleEndDate)
  } as DateIntervalFilterData : {
    ...dateFilter,
    interval: pageFilter.interval,
    granularity: pageFilter.granularity
  };
}